// One-time migration from the pre-rename "BWAMICRO:*" keys to "CLASS:*" so
// nobody gets logged out. Imported first in src/index.js; runs on import,
// before anything reads storage.
import { migrateLegacyUserCookie } from "lib/userCookie";

["redirect"].forEach((key) => {
  try {
    const legacyKey = `BWAMICRO:${key}`;
    const newKey = `CLASS:${key}`;
    const legacy = localStorage.getItem(legacyKey);
    if (legacy !== null && localStorage.getItem(newKey) === null) {
      localStorage.setItem(newKey, legacy);
    }
    localStorage.removeItem(legacyKey);
  } catch (e) {
    // Ignore: storage unavailable (private mode, blocked site data).
  }
});

// Sessions moved to an httpOnly cookie set by the API; the old
// JWTs in storage are useless now, so drop them.
["CLASS:token", "BWAMICRO:token"].forEach((key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
});

migrateLegacyUserCookie();
